import LTR from "@brand-icons/global/social-x/social-x-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialXIcon = iconFactory("SocialXIcon", LTR);
